import classes from './Backdrop.module.css';

const Backdrop = (props) => {

    // onClick={props.hide} // remove this line to remove the click handler
    return <div className={`${classes.backdrop} ${props.over ? classes.backdrop_over : ''} ${props.onTop ? classes.main_modal : ''} ${props.underHeader ? classes.backdrop_below_header : ''} ${props.noBlur ? classes.backdrop_no_blur : ''}`} onClick={props.hideEnabled ? props.hide : null}></div>
}

export default Backdrop;